import CryptoJS from "crypto-js";

// Nueva API Laravel (Backend unificado)
export const newApiBaseUrl = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

// URL BASE para archivos estáticos/documentos (configurar según donde estén alojados los archivos legacy)
// Puede ser: altrisa-be storage, servidor antiguo, o CDN
export const filesBaseUrl = process.env.REACT_APP_FILES_URL || process.env.REACT_APP_API_URL?.replace('/api', '/storage') || "http://localhost:8000/storage";

// Mantener compatibilidad con código legacy (DEPRECADAS - usar newApiBaseUrl)
const baseUrl = newApiBaseUrl;
export const baseUrlOld = newApiBaseUrl; // Ahora apunta al nuevo backend
export const api = newApiBaseUrl;

// URLs para el backend Laravel unificado (altrisa-be)
// AUTENTICACIÓN
export const authUrl = `${newApiBaseUrl}/auth`;
export const loginUrl = `${newApiBaseUrl}/auth/login`;
export const logoutUrl = `${newApiBaseUrl}/auth/logout`;

// USUARIOS
export const userUrl = `${newApiBaseUrl}/users`;
export const asesoresUrl = `${newApiBaseUrl}/users/asesores`;
export const sessionUrl = `${newApiBaseUrl}/auth`;

// CLIENTES
export const clienteUrl = `${newApiBaseUrl}/clientes`;
export const clienteValidarUrl = `${newApiBaseUrl}/clientes/validar`;
export const clientesPorIdUrl = (id) => `${newApiBaseUrl}/clientes/${id}`;

// PRÉSTAMOS
export const prestamosUrl = `${newApiBaseUrl}/prestamos`;
export const prestamosCreateUrl = `${newApiBaseUrl}/prestamos`;
export const prestamosInitialDataUrl = `${newApiBaseUrl}/prestamos/initial-data`;
export const prestamosListarPorClienteUrl = `${newApiBaseUrl}/prestamos/listar-por-cliente`;
export const prestamosCronogramaUrl = (id) => `${newApiBaseUrl}/prestamos/${id}/cronograma`;
export const prestamosRccUrl = (id) => `${newApiBaseUrl}/prestamos/${id}/rcc`;

// PAGOS
export const pagosUrl = `${newApiBaseUrl}/pagos`;
export const historialPagosUrl = `${newApiBaseUrl}/pagos`;
export const pagosOtrosUrl = `${newApiBaseUrl}/pagos-otros`;

// JUNTAS
export const juntaUrl = `${newApiBaseUrl}/juntas`;
export const juntaPlanUrl = `${newApiBaseUrl}/junta-plans`;

// CUADRE DE CAJA
export const cuadreDiarioUrl = `${newApiBaseUrl}/cuadres-caja`;
export const cuadreCajaPdfUrl = (id) => `${newApiBaseUrl}/cuadres-caja/${id}/pdf`;
export const cuadreCajaIngresosUrl = `${newApiBaseUrl}/cuadres-caja-ingresos`;

// CAJAS
export const cajaUrl = `${newApiBaseUrl}/cajas`;
export const cajasActivasUrl = `${newApiBaseUrl}/cajas?estado=1`;

// PRE EVALUACIONES
export const preEvaluacionUrl = `${newApiBaseUrl}/pre-evaluaciones`;

// REPORTES
export const reportesUrl = `${newApiBaseUrl}/reportes`;
export const reportesColocacionesUrl = `${newApiBaseUrl}/reportes/colocaciones`;
export const reportesColocacionesDetalleUrl = `${newApiBaseUrl}/reportes/colocaciones/detalle`;
export const resumenDiarioUrl = `${newApiBaseUrl}/reportes/diario`;

// COBRANZA DIARIA
export const cobranzaDiariaUrl = `${newApiBaseUrl}/cobranza-diaria`;

// RENIEC Y VALIDACIONES
export const reniecUrl = `${newApiBaseUrl}/cliente-validacion/reniec`;

// RUTAS
export const rutasUrl = `${newApiBaseUrl}/rutas`;

// CALCULADORA
export const calculadoraUrl = `${newApiBaseUrl}/calculadora/calcular`;
export const calculadoraSimularUrl = `${newApiBaseUrl}/calculadora/simular`;

// ENUMS Y CONSTANTES
export const enumsUrl = `${newApiBaseUrl}/enums`;

// SCORING
export const scoringUrl = `${newApiBaseUrl}/scoring`;

// PDFs
export const clientePdfPorAsesorUrl = (id) => `${newApiBaseUrl}/clientes/pdf/asesor/${id}`;
export const clientePdfActivosUrl = `${newApiBaseUrl}/clientes/pdf/activos`;


// FUNCIONES DE USUARIO ACTUALIZADAS PARA EL NUEVO SISTEMA DE AUTENTICACIÓN

/**
 * Obtiene el ID del usuario autenticado del nuevo sistema
 * @returns {number|null} ID del usuario o null si no está autenticado
 */
export function UserCod() {
  try {
    const userData = localStorage.getItem("user_data");
    if (userData) {
      const user = JSON.parse(userData);
      return user.id || null;
    }
  } catch (error) {
    console.error("Error obteniendo ID de usuario:", error);
    return null;
  }
}

/**
 * Obtiene todos los datos del usuario autenticado
 * @returns {Object|null} Datos completos del usuario o null
 */
export function GetUserData() {
  try {
    const userData = localStorage.getItem("user_data");
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  } catch (error) {
    console.error("Error obteniendo datos de usuario:", error);
    return null;
  }
}

/**
 * Obtiene el nombre completo del usuario autenticado
 * @returns {string} Nombre completo del usuario o "Usuario"
 */
export function GetUserName() {
  const userData = GetUserData();
  return userData?.full_name || userData?.name || "Usuario";
}

/**
 * Obtiene el tipo/rol del usuario autenticado
 * @returns {Object} Información del rol del usuario
 */
export function GetUserRole() {
  const userData = GetUserData();
  if (!userData) return { role: null, description: "Usuario", tip_user: null };
  
  return {
    role: userData.role || null,
    description: userData.role_description || "Usuario",
    tip_user: userData.tip_user || null,
    color: userData.role_color || "secondary"
  };
}

/**
 * Verifica si el usuario actual es administrador
 * @returns {boolean} True si es administrador
 */
export function IsAdmin() {
  const userData = GetUserData();
  return userData?.tip_user === 1 || userData?.role === 'admin';
}

/**
 * Verifica si el usuario actual es auditor
 * @returns {boolean} True si es auditor
 */
export function IsAuditor() {
  const userData = GetUserData();
  return userData?.tip_user === 3 || userData?.role === 'auditor';
}

/**
 * Verifica si hay un usuario autenticado
 * @returns {boolean} True si hay usuario autenticado
 */
export function IsAuthenticated() {
  const token = localStorage.getItem("auth_token");
  const userData = localStorage.getItem("user_data");
  return !!(token && userData);
}

/**
 * Verifica si el usuario tiene permiso para una acción/módulo específico
 * @param {string} accion - Nombre de la acción o módulo a verificar
 * @param {Object} tiposPermitidos - Objeto con los tipos de usuario permitidos
 * @returns {boolean} True si tiene permiso
 */
export function TienePermiso(accion, tiposPermitidos) {
  const userData = GetUserData();
  if (!userData || !userData.tip_user) return false;
  
  const tipoUsuario = userData.tip_user;
  const permisosAccion = tiposPermitidos[accion];
  
  if (!permisosAccion || !Array.isArray(permisosAccion)) return false;
  
  // Convertir tanto el tipo de usuario como los permisos a string para comparación
  const tipoUsuarioStr = String(tipoUsuario);
  return permisosAccion.map(String).includes(tipoUsuarioStr);
}

/**
 * Obtiene el tipo de usuario actual como número
 * @returns {number|null} Tipo de usuario (1=admin, 2=usuario, 3=auditor, etc.)
 */
export function GetTipoUsuario() {
  const userData = GetUserData();
  return userData?.tip_user || null;
}
export function MonedaPen(monto) {
  if (monto === null) {
    return "0.00";
  }

  var valorEnSoles = parseFloat(monto);
  if (isNaN(valorEnSoles)) {
    return "0.00";
  }

  var formatoMoneda = valorEnSoles.toLocaleString("es-PE", {
    style: "currency",
    currency: "PEN",
  });
  return formatoMoneda;
}

export function FechaActual() {
  const fechaActual = new Date();
  const anio = fechaActual.getFullYear();
  const mes = (fechaActual.getMonth() + 1).toString().padStart(2, "0");
  const dia = fechaActual.getDate().toString().padStart(2, "0");
  const fechaEnFormato = `${anio}-${mes}-${dia}`;

  return fechaEnFormato;
}

export function HoraActual() {
  const fechaActual = new Date();
  const horas = fechaActual.getHours().toString().padStart(2, "0");
  const minutos = fechaActual.getMinutes().toString().padStart(2, "0");
  const segundos = fechaActual.getSeconds().toString().padStart(2, "0");
  const horaActual = `${horas}:${minutos}:${segundos}`;

  return horaActual;
}

export function FechaActualCompleta() {
  const fechaActual = new Date();
  const anio = fechaActual.getFullYear();
  const mes = (fechaActual.getMonth() + 1).toString().padStart(2, "0");
  const dia = fechaActual.getDate().toString().padStart(2, "0");
  const horas = fechaActual.getHours().toString().padStart(2, "0");
  const minutos = fechaActual.getMinutes().toString().padStart(2, "0");
  const segundos = fechaActual.getSeconds().toString().padStart(2, "0");
  const fechaEnFormato = `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;

  return fechaEnFormato;
}
export function UrlGet(data) {
  const data2 = {};
  for (const prop in data) {
    if (data.hasOwnProperty(prop) && data[prop] !== null && data[prop] !== "") {
      data2[prop] = data[prop];
    }
  }
  const searchParams = new URLSearchParams(data2);
  const queryString = "?" + searchParams.toString();
  return queryString;
}
export function UrlPost(datosEnviar) {
  const formdata = new FormData();
  for (const key in datosEnviar) {
    if (datosEnviar[key] !== null && datosEnviar[key] !== "") {
      formdata.append(key, datosEnviar[key]);
    }
  }
  return formdata;
}

export function UrlHeader() {
  var myHeaders = new Headers();
  const token = localStorage.getItem('auth_token');
  if (token) {
    myHeaders.append("Authorization", `Bearer ${token}`);
  }
  return myHeaders;
}
/**
 * Obtiene los datos del usuario actual (DEPRECADA - usar GetUserData())
 * @deprecated Use GetUserData() instead for better performance
 * @returns {Object} Datos del usuario desde localStorage
 */
export function MisDatos() {
  // Retornar datos directamente desde localStorage (más eficiente)
  const userData = GetUserData();
  if (userData) {
    return userData;
  }

  // Fallback al método anterior si no hay datos en localStorage
  var id_user = UserCod();
  var retornar = {};
  
  if (id_user) {
    fetch(userUrl + id_user, {
      method: "GET",
      headers: UrlHeader(),
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          return result.data;
        }
      })
      .catch((error) => console.log("error", error));
  }
  
  return retornar;
}
export function OrdenarPorFecha(array) {
  array.sort(function (a, b) {
    const dateA = new Date(a.fecha);
    const dateB = new Date(b.fecha);
    return dateB - dateA;
  });
  return array;
}
export function QuitarRegistrosCero(data) {
  var result = [];

  for (var i = 0; i < data.length; i++) {
    if (
      data[i].total !== "0" &&
      data[i].total !== 0 &&
      data[i].total !== "0.00"
    ) {
      result.push(data[i]);
    }
  }
  return result;
}
/**
 * Valida si hay una sesión activa (actualizada para nuevo sistema)
 */
export function ValidarSesionActiva() {
  // Verificar nuevo sistema de autenticación
  if (IsAuthenticated()) {
    // console.log("mantener sesion");
    return true;
  }
  
  // Fallback al sistema viejo
  if (localStorage.getItem("SESSIONDATA")) {
    // console.log("mantener sesion");
    return true;
  }
  
  // No hay sesión activa, limpiar y redirigir
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "./";
  return false;
}

/**
 * Verifica y limpia sesiones expiradas (actualizada para nuevo sistema)
 */
export function checkValidarSesionActiva() {
  // Verificar el nuevo sistema
  const token = localStorage.getItem("auth_token");
  const userData = localStorage.getItem("user_data");
  
  if (token && userData) {
    // El token JWT ya maneja su propia expiración
    // Si llegamos aquí, la sesión es válida
    return true;
  }
  
  // Fallback al sistema viejo
  const itemStr = localStorage.getItem("SESSIONDATA");
  if (itemStr) {
    try {
      const item = JSON.parse(itemStr);
      if (new Date().getTime() > item.expiry) {
        localStorage.removeItem("SESSIONDATA");
        return false;
      }
      return true;
    } catch (error) {
      localStorage.removeItem("SESSIONDATA");
      return false;
    }
  }
  
  return false;
}
export function esFechaHoy(fecha) {
  const fechaHoy = new Date();
  const diaHoy = fechaHoy.getDate();
  const mesHoy = fechaHoy.getMonth() + 1;
  const añoHoy = fechaHoy.getFullYear();

  const fechaObjeto = new Date(fecha);
  const diaFecha = fechaObjeto.getDate();
  const mesFecha = fechaObjeto.getMonth() + 1;
  const añoFecha = fechaObjeto.getFullYear();
  if (diaHoy === diaFecha && mesHoy === mesFecha && añoHoy === añoFecha) {
    return true;
  } else {
    return false;
  }
}
export function redondearADosDecimales(numero) {
  const numeroRedondeado = Math.round(numero * 10) / 10;
  const numeroFormateado = numeroRedondeado.toFixed(2);
  return numeroFormateado;
}
export function redondearAFavor(numero) {
  if (isNaN(numero) || numero === null || numero === undefined) return 0;
  return Math.ceil(Math.round(Number(numero) * 100) / 10) / 10;
}
/**
 * Obtiene el nombre del estado de préstamo (actualizado para nuevos estados)
 * @param {number|string} estado - El estado del préstamo
 * @returns {string} Nombre del estado
 */
export function estadosPrestamoName(estado) {
  const estadoNum = parseInt(estado);
  
  switch (estadoNum) {
    case 0:
      return "PRE APROBADO";
    case 1:
      return "POR DESEMBOLAR";
    case 2:
      return "NEGADO";
    case 3:
      return "ACTIVO";
    case 4:
      return "CANCELADO";
    default:
      return "DESCONOCIDO";
  }
}

/**
 * Obtiene el color del estado de préstamo para UI
 * @param {number|string} estado - El estado del préstamo
 * @returns {string} Clase de color CSS
 */
export function estadosPrestamoColor(estado) {
  const estadoNum = parseInt(estado);
  
  switch (estadoNum) {
    case 0:
      return "warning"; // PRE APROBADO
    case 1:
      return "info";    // POR DESEMBOLAR
    case 2:
      return "danger";  // NEGADO
    case 3:
      return "success"; // ACTIVO
    case 4:
      return "secondary"; // CANCELADO
    default:
      return "secondary";
  }
}

/**
 * Constantes de estados de préstamos (sincronizadas con el backend)
 */
export const ESTADOS_PRESTAMO = {
  PRE_APROBADO: 0,
  POR_DESEMBOLSAR: 1,
  NEGADO: 2,
  ACTIVO: 3,
  CANCELADO: 4
};

/**
 * Constantes de tipos de interés
 */
export const TIPOS_INTERES = {
  DIARIO: 'diario',
  SEMANAL: 'semanal',
  MENSUAL: 'mensual',
  ANUAL: 'anual'
};

/**
 * Constantes de formas de pago
 */
export const FORMAS_PAGO = {
  DIARIO: 'diario',
  SEMANAL: 'semanal',
  QUINCENAL: 'quincenal',
  MENSUAL: 'mensual'
};

/**
 * Obtiene todos los enums desde el backend
 * @returns {Promise<Object>} Datos de enums
 */
export async function fetchEnums() {
  try {
    const response = await fetch(`${newApiBaseUrl}/enums`);
    if (response.ok) {
      const data = await response.json();
      return data.data;
    }
    throw new Error('Error al obtener enums');
  } catch (error) {
    console.error('Error fetching enums:', error);
    return null;
  }
}

/**
 * Obtiene constantes específicas desde el backend
 * @returns {Promise<Object>} Constantes del sistema
 */
export async function fetchConstants() {
  try {
    const response = await fetch(`${newApiBaseUrl}/enums/constants`);
    if (response.ok) {
      const data = await response.json();
      return data.data;
    }
    throw new Error('Error al obtener constantes');
  } catch (error) {
    console.error('Error fetching constants:', error);
    return null;
  }
}

/* 
EJEMPLOS DE USO DE LAS NUEVAS FUNCIONES:

// Obtener ID del usuario actual
const userId = UserCod(); // Ejemplo: 40

// Obtener todos los datos del usuario
const userData = GetUserData(); 
// Ejemplo: {id: 40, name: "Stanley", full_name: "Stanley Saavedra Dominguez", ...}

// Obtener nombre del usuario
const userName = GetUserName(); // Ejemplo: "Stanley Saavedra Dominguez"

// Obtener información del rol
const roleInfo = GetUserRole();
// Ejemplo: {role: "admin", description: "Administrador", tip_user: 1, color: "danger"}

// Verificar permisos
if (IsAdmin()) {
  console.log("Usuario es administrador");
}

if (IsAuditor()) {
  console.log("Usuario es auditor");
}

// Verificar autenticación
if (IsAuthenticated()) {
  console.log("Usuario está autenticado");
}

// En un componente React, usar preferiblemente el contexto:
// const { user } = useNewAuth();
*/
